import React from "react";
import { PRIORITY_FIT_COVER } from "utils/constants/ui";
import { useResizeDetector } from "react-resize-detector";
import Image from "components/Image";
import { useViewport } from "utils/context";

const LogoConnection = ({ src }) => {
  const { width, height, ref } = useResizeDetector();
  const ctxWidth = width || 0;
  const ctxHeight = height || 0;

  const dimensions = {
    width: ctxWidth,
    height: ctxHeight
  };

  let imageProps = {
    alt: "alt",
    ...dimensions,
    src,
    ...PRIORITY_FIT_COVER
  };
  const { isSmall } = useViewport();
  const factor = isSmall ? 4 : 3;

  return (
    <div
      style={{ height: 458 / factor, width: 984 / factor }}
      className="relative center"
      ref={ref}
    >
      <Image {...imageProps} />
    </div>
  );
};

export default LogoConnection;
